// Polyfills for Node.js modules in browser environment
import { Buffer } from 'buffer';
import process from 'process/browser';

// Make Buffer available globally
window.Buffer = Buffer;
global.Buffer = Buffer;

// Make process available globally  
window.process = process;
global.process = process;

// Ensure global is defined
if (typeof global === 'undefined') {
  window.global = window;
}
